import { render, staticRenderFns } from "./ColoredContentBlock.vue?vue&type=template&id=9650d2fc&scoped=true&"
import script from "./ColoredContentBlock.vue?vue&type=script&lang=js&"
export * from "./ColoredContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColoredContentBlock.vue?vue&type=style&index=0&id=9650d2fc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9650d2fc",
  null
  
)

export default component.exports